import React from 'react';
import {connect} from 'react-redux';
import * as Constants from "../../Common/constants";
import PlayerItem from '../PlayerItem/PlayerItem.js';

export class LeaderboardWidget extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = { serverErrors: {}};
       
        
        console.info('LeaderboardWidget - constructor called.');
    }

    componentWillMount() {
        console.info('LeaderboardWidget - componentWillMount called.');
    }

    componentDidMount() {
        console.info('LeaderboardWidget - componentDidMount called.');
        this.loadLeaderboard();
    }

    componentWillReceiveProps(nextProps) {
        console.info('LeaderboardWidget - componentWillReceiveProps called.');
        if (nextProps.lastitem && nextProps.lastitem.type === Constants.EVENT_TYPE_RESULT){
            this.loadLeaderboard();
        }
       
    }

    shouldComponentUpdate() {
        return true;
    }

    componentWillUpdate() {
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
    }


    onChange(e) {
       
    }


    render() {
        console.info('LeaderboardWidget - render called.');
        let leaderboard = this.state.leaderboard;
        if (!leaderboard){
            return null;
        }

        console.info('LeaderboardWidget - render called.', leaderboard);
        let playerItems = [];
        leaderboard.players.forEach(element => {
            playerItems.push(<PlayerItem key={element.id} data={element}/>)
        });
        return playerItems;
    }

   loadLeaderboard(){
    console.log("loadLeaderboard");
    var url = Constants.SERVER + "/leaderboard/" + Constants.LEADERBOARD_ID;
    var component = this;
    fetch(url)
    .then(function(response) {
      return response.json();
    })
    .then(function(json) {
       
        component.setState({
            leaderboard: json.leaderboard
         })
      
    });
   }
    
}
const mapStateToProps = state => ({
   lastitem: state.leaderboard.last
});

/**
* Import action from dir action above - but must be passed to connect method in order to trigger reducer in store
* @type {{UserUpdate: UserUpdateAction}}
*/
const mapActionsToProps = {
  
};
export default connect(mapStateToProps, mapActionsToProps)(LeaderboardWidget);



// WEBPACK FOOTER //
// ./src/Components/LeaderboardWidget/LeaderboardWidget.js